export function getTagColor(tag: string) {
  const colorMap = {
    ANULADO: '#ef4444',
    PENDIENTE: '#f59e0b',
    PENDING: '#f59e0b',
    AGRUPADO: '#22c55e',
    EMIT: '#22c55e',
    CASH: '#10b981',
    EFECTIVO: '#10b981',
    TARJETA: '#f78f47',
    BILLETERA: '#8c2ca9',
    BANCO: '#538ff1',
    BOLETA: '#43a047',
    FACTURA: '#07b0b0',
    CREADO: '#dc8e07',
    ACEPTADO: '#22c55e',
    BAJA: '#cb4646',
    MEDIA: '#f59e0b',
    ALTA: '#10b981',
    CRM: '#f59e0b',
    SRM: '#41b883',
    'CRM-R': '#cb4646',
    'escaso': '#f59e0b',
    'agotado': '#ef4444',
    'suficiente': '#22c55e',
    'activo': '#22c55e',
    'cerrado': '#f59e0b',
  };
  return colorMap[tag] || 'info';
}
